import { LandingNav, Footer } from './LandingPage';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-background" data-testid="terms-page">
      <LandingNav />
      <div className="pt-24 pb-16 px-6">
        <div className="max-w-3xl mx-auto">
          <h1 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight mb-2">Terms of Service</h1>
          <p className="text-sm text-muted-foreground mb-10">Last updated: February 2026</p>

          <div className="space-y-8 text-sm text-muted-foreground leading-relaxed">
            <section>
              <h2 className="font-heading text-lg font-semibold text-foreground mb-3">1. Acceptance of Terms</h2>
              <p>By accessing or using Slate, you agree to be bound by these Terms of Service. If you are using Slate on behalf of an organization, you represent that you have the authority to bind that organization to these terms. If you do not agree, do not use the platform.</p>
            </section>

            <section>
              <h2 className="font-heading text-lg font-semibold text-foreground mb-3">2. Account Responsibilities</h2>
              <p>You are responsible for maintaining the security of your account credentials and for all activity under your account. You must provide accurate information during registration and keep it updated. Notify us immediately if you suspect unauthorized access to your account.</p>
            </section>

            <section>
              <h2 className="font-heading text-lg font-semibold text-foreground mb-3">3. Permitted Use</h2>
              <p>Slate is designed for creative project management and collaboration. You may use the platform to manage projects, find collaborators via the AINAA network, utilize AI-powered tools, and process payments for creative work. You may not use Slate for any unlawful purpose or to harass, abuse, or harm others.</p>
            </section>

            <section>
              <h2 className="font-heading text-lg font-semibold text-foreground mb-3">4. Intellectual Property</h2>
              <p>You retain full ownership of all content, files, and creative work you upload to Slate. We do not claim any intellectual property rights over your content. Slate's interface, branding, AI models, and code remain the property of Slate and its licensors.</p>
            </section>

            <section>
              <h2 className="font-heading text-lg font-semibold text-foreground mb-3">5. AI Services (Specter & Introw)</h2>
              <p>Specter AI and Introw matchmaking provide suggestions and recommendations based on available data. These outputs are informational and should not be treated as professional advice. Slate is not liable for decisions made based on AI-generated content. Budget estimates, timelines, and matchmaking results are approximations.</p>
            </section>

            <section>
              <h2 className="font-heading text-lg font-semibold text-foreground mb-3">6. Crowdfunding & Payments</h2>
              <p>Film showcase crowdfunding features connect creators with supporters. Slate facilitates the platform but does not guarantee project completion. Refund policies for backed projects are determined by the project creator. Payment processing is handled by third-party providers subject to their own terms.</p>
            </section>

            <section>
              <h2 className="font-heading text-lg font-semibold text-foreground mb-3">7. Service Availability</h2>
              <p>We strive to keep Slate available at all times, but we do not guarantee uninterrupted service. We may temporarily suspend access for maintenance, updates, or security reasons. We will provide reasonable notice for planned downtime when possible.</p>
            </section>

            <section>
              <h2 className="font-heading text-lg font-semibold text-foreground mb-3">8. Termination</h2>
              <p>You may close your account at any time through Settings. We reserve the right to suspend or terminate accounts that violate these terms. Upon termination, you may export your data within 30 days, after which it will be permanently deleted.</p>
            </section>

            <section>
              <h2 className="font-heading text-lg font-semibold text-foreground mb-3">9. Limitation of Liability</h2>
              <p>Slate is provided "as is" without warranties of any kind. To the maximum extent permitted by law, Slate shall not be liable for indirect, incidental, special, or consequential damages arising from your use of the platform.</p>
            </section>

            <section>
              <h2 className="font-heading text-lg font-semibold text-foreground mb-3">10. Contact</h2>
              <p>For questions about these terms, contact us at <span className="text-foreground font-medium">legal@slate.app</span>.</p>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
